<template>
  <div class="support-page">
    <Headers />
    <!-- Hero Section with Background Image -->
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <h1 class="hero-title">Support Center</h1>
        <p class="hero-description">Welcome to Fortvue service and support</p>
      </div>
    </div>

    <!-- Contact Information Section -->
    <div class="contact-section">
      <div class="contact-container">
        <div class="contact-grid">
          <!-- Email Card -->
          <div class="contact-card">
            <div class="card-icon">
              <svg
                class="w-12 h-12 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h2 class="card-title">Email Us</h2>
            <a
              href="mailto:support@fortvue.com"
              class="card-content email-link"
            >
              support@fortvue.com
            </a>
          </div>

          <!-- Address Card -->
          <div class="contact-card">
            <div class="card-icon">
              <svg
                class="w-12 h-12 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <h2 class="card-title">Address</h2>
            <address class="card-content">
              <p class="font-semibold">FORTVUE LIMITED</p>
              <p>Flat/Rm A, 12/F, ZJ 300</p>
              <p>300 Lockhart Road</p>
              <p>Wan Chai, Hong Kong</p>
            </address>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script lang="js">
import Headers from '@/components/Headers.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: "SupportPage",
  components: {
    Headers,
    Footer
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.support-page {
  display: flex;
  flex-direction: column;
}
/* Hero Section */
.hero-section {
  position: relative;
  height: 400px;
  background-image: url("http://img-for-hk.wds168.cn/comdata/6482285/201705/20170531164321265495.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 1.25rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* Contact Section */
.contact-section {
  flex: 1;
  background: linear-gradient(to bottom, #f7fafc, #edf2f7);
  padding: 2rem 1rem;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-top: 2rem;
}

/* Contact Cards */
.contact-card {
  background: white;
  border-radius: 0.4rem;
  padding: 2rem 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.card-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.card-icon svg {
  width: clamp(2.5rem, 8vw, 3rem);
  height: clamp(2.5rem, 8vw, 3rem);
}

.card-title {
  font-size: clamp(1.25rem, 3vw, 1.5rem);
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1.5rem;
}

.card-content {
  font-size: clamp(0.875rem, 2vw, 1rem);
  color: #4a5568;
  line-height: 1.8;
  font-style: normal;
  word-break: break-word;
}

.card-content p {
  margin-bottom: 0.5rem;
}

.email-link {
  color: #3182ce;
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  transition: color 0.2s ease;
  word-break: break-all;
}

.email-link:hover {
  color: #2c5aa0;
  text-decoration: underline;
}

/* Tablet Responsive */
@media (min-width: 640px) {
  .contact-section {
    padding: 3rem 1.5rem;
  }

  .contact-card {
    padding: 2.5rem 2rem;
  }

  .hero-content {
    padding: 0 2rem;
  }
}

/* Desktop Responsive */
@media (min-width: 768px) {
  .contact-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  .contact-section {
    padding: 4rem 2rem;
  }
}

/* Large Desktop */
@media (min-width: 1024px) {
  .contact-card {
    padding: 2.5rem;
  }
}

/* Mobile Responsive */
@media (max-width: 639px) {
  .hero-section {
    height: 400px;
  }

  .contact-section {
    padding-bottom: 2rem;
  }
}

/* Extra Small Mobile */
@media (max-width: 375px) {
  .hero-section {
    height: 350px;
  }

  .hero-content {
    padding: 0 1rem;
  }

  .contact-card {
    padding: 1.5rem 1rem;
  }

  .card-icon {
    margin-bottom: 1rem;
  }

  .card-title {
    margin-bottom: 1rem;
  }
}
</style>
